import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import "swiper/css";
import "swiper/css/autoplay";

//パラメータは以下参照
//https://swiperjs.com/swiper-api#parameters

export function slider2(slider2El) {
  if ($(slider2El).length) {
    const swiper2 = new Swiper(slider2El, {
      direction: "horizontal",
      loop: true,
      autoHeight: false,
      speed: 6000,
      modules: [Autoplay],
      allowTouchMove: false,
      centeredSlides: true,
      initialSlide: 5,
      autoplay: {
        delay: 0,
      },
      slidesPerView: 'auto',
      // slidesPerView: 6,
      spaceBetween: 60,
      // Responsive breakpoints
    });
    // 一時停止
    $(".p-slider--citizen__ctrl .swiper_pause").on("click", function(){
      swiper2.autoplay.stop();
      $(this).parent().find('button').removeClass('is-active');
      $(this).addClass("is-active");

      console.log(parent);
    });
    //再生
    $(".p-slider--citizen__ctrl .swiper_start").on("click", function(){
      swiper2.autoplay.start();
      $(this).parent().find('button').removeClass('is-active');
      $(this).addClass("is-active");
    });

  }
}
